const PropTypes = require('prop-types');
const React = require('react');

const APIRequest = require('../api_request.js');
const Upsell = require('../product_show_page/upsell.jsx');
const UrlHelpers = require('components/shared/url_helpers.js');
const { UserStore, Tracker } = require('@reverbdotcom/discovery-ui');
const AddToCartButton = require('components/listings/cart/add_to_cart_button.jsx');

const VIEW_TYPE = 'cart_view_upsells';
const AID = 'cart_view_related_content_upsells';
const UPSELLS_MAX = 4;

class CartUpsells extends React.Component {
  constructor() {
    super();

    this.state = {
      upsells: [],
    };
  }

  componentDidMount() {
    this.fetchUpsells();
  }

  fetchUpsells() {
    if (this.upsellsDisabled()) { return; }

    APIRequest.V3.get(
      UrlHelpers.upsellsPath(),
      {
        include_grid_images: true,
        id: this.props.listingIds,
      }
    ).then((response) => {
      const upsells = (response.upsells || []).slice(0, UPSELLS_MAX);

      this.setState({
        upsells,
      });

      this.trackUpsells(upsells);
    });
  }

  trackUpsells(upsells) {
    if (!upsells.length) { return null; }

    Tracker.view({
      name: VIEW_TYPE,
      type: 'listings',
      ids: upsells.map(l => l.id),
    });
  }

  get hasUpsells() {
    return this.state.upsells.length;
  }

  upsellsDisabled() {
    return UserStore.getState().countryCode !== 'US';
  }

  shouldShowTopPick(upsell, index) {
    return index === 0 && upsell.top_pick === true;
  }

  renderUpsells() {
    return this.state.upsells.map((upsell, index) =>
      <Upsell
        upsell={upsell}
        key={upsell.id}
        aid={AID}
        showTopPick={this.shouldShowTopPick(upsell, index)}
        addToCartButton={AddToCartButton}
      />
    );
  }

  render() {
    if (this.upsellsDisabled()) { return null; }
    if (!this.hasUpsells) { return null; }

    return (
      <div className={this.props.className}>
        {this.props.children}
        <h4 className="upsells__section-title">
          <span className="upsells__section-title__logo"></span>
          {I18n.t('productShowPage.recommends')}
        </h4>
        <ul className="card-grid card-grid--4up">
          {this.renderUpsells()}
        </ul>
      </div>
    );
  }
}

CartUpsells.propTypes = {
  listingIds: PropTypes.array,
  className: PropTypes.string,
  children: PropTypes.node,
};

module.exports = CartUpsells;



// WEBPACK FOOTER //
// ./javascripts/components/cart/cart_upsells.jsx